<script>
import SideBar from '@/layouts/partials/SideBar.vue';
import MobileTopNav from '@/layouts/partials/MobileTopNav.vue';
import {mapState} from 'vuex';
import OwnerApi from '@/api/owner';
import VendorApi from '@/api/vendor';
import ReservationApi from '@/api/reservation';

export default {
  name: 'AdminOwnerLayout',
  components: {SideBar, MobileTopNav},
  data() {
    return {
      checkingAccount: true,
      portal: ''
    };
  },
  computed: {
    ...mapState({
      sidebarCollapse: state => state.common.sidebarCollapse,
      loadingData: state => state.common.loadingData
    })
  },
  beforeMount() {
    const settings = this.$helper.Session.getLoginSettings();
    this.portal = settings.portal;

    if (!this.$helper.getToken() && this.portal !== this.$helper.Portals.STAFF) {
      return this.$helper.logout();
    }

    // Refresh account info if needed
    if (!this.$store.state.common.accountInformation) {
      switch (settings.portal) {

        case this.$helper.Portals.OWNER: {
          OwnerApi.getAccountDetail().then(response => {
            this.$store.dispatch('common/updateAccountInfo', response.data.result);
            this.checkingAccount = false;
          })
            .catch(() => {
              this.$helper.logout();
            });
          break;
        }

        case this.$helper.Portals.VENDOR: {
          VendorApi.getAccountDetail().then(response => {
            this.$store.dispatch('common/updateAccountInfo', response.data.result);
            this.$store.dispatch('common/updateDate', {
              startDate: this.$moment().format('MM/DD/YYYY'),
              endDate: this.$moment().format('MM/DD/YYYY')
            });
            this.checkingAccount = false;
          })
            .catch(() => {
              this.$helper.logout();
            });
          break;
        }

        case this.$helper.Portals.RESERVATION: {
          ReservationApi.getUnitDetails().then(response => {
            this.$store.dispatch('common/updateUnitDetails', response.data.result);
            ReservationApi
              .getReservationDetails()
              .then(response => {
                this.$store.dispatch('common/updateReservationDetails', response.data.result);
                this.checkingAccount = false;
              })
              .catch(() => {
                this.$helper.logout();
              });
          })
            .catch(() => {
              this.$helper.logout();
            });

          break;
        }

        case this.$helper.Portals.STAFF: {
          this.checkingAccount = false;
          this.$router.push('/');
        }
      }
    } else {
      this.$nextTick(() => {
        if (settings.portal === this.$helper.Portals.VENDOR) {
          if (this.$store.state.common.datePicked === null) {
            this.$store.dispatch('common/updateDate', {
              startDate: this.$moment().format('MM/DD/YYYY'),
              endDate: this.$moment().format('MM/DD/YYYY')
            });
          }

          VendorApi.getCleaningInfo(this.$store.state.common.datePicked).then(response => {
            this.$store.dispatch('common/updateCleaningInfo', response.data.result);
          });
        }
        this.checkingAccount = false;
      });
    }
  }
};
</script>

<template>
  <div class="admin-layout" :class="{ 'mobile-active-sidebar': !sidebarCollapse }">
    <div v-if="!checkingAccount">
      <div v-show="loadingData" class="loading-container">
        <div class="overlay" />
        <div class="loading">
          <div class="ball-clip-rotate-pulse">
            <div />
            <div />
          </div>
        </div>
      </div>
      <div class="v-sidebar d-print-none">
        <side-bar />
      </div>
      <div class="mobile-nav-container">
        <mobile-top-nav />
      </div>
      <div class="v-wrapper">
        <router-view />
      </div>
    </div>
    <div
      v-show="checkingAccount"
      class="checking-account-info text-center">
      <p v-if="portal !== 'reservation'" class="font-medium type-24">
        Checking account information...
      </p>
      <p v-if="portal === 'reservation'" class="font-medium type-24">
        Checking reservation information...
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
